module.exports = __webpack_public_path__ + "img/arrow-down.81c69d31.png";